import React from 'react'
import { Alert, Snackbar } from '@mui/material'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { sensitiveMarkErrorText } from './sensitiveMarks'

// Story 213 v2 (C7.1, H-v2-17): a rejected marking always shows as a snackbar with Sun's message translated, the gaps
// interpolated. Shared by the switch, the widget editor and the document table.
const SensitiveMarkErrorSnackbar = ({ message, onClose }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Snackbar open={message !== ''} autoHideDuration={8000} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert data-testid='sensitive-mark-error' severity='error' variant='filled' onClose={onClose}>
        {message !== '' ? sensitiveMarkErrorText(message, t_) : ''}
      </Alert>
    </Snackbar>
  )
}

export default SensitiveMarkErrorSnackbar
